import * as React from 'react'
import { css } from 'styled-components/macro'

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = 'div'

interface Props extends React.ComponentPropsWithoutRef<typeof Root> {}

function Segmented(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const { children, ...rest } = props

  return (
    <Root ref={ref} css={styles.root as any} {...rest}>
      <div css={styles.grid as any}>{children}</div>
    </Root>
  )
}

const styles = {
  root: css`
    --gutter: 28px;
    --gutter-half: calc(var(--gutter) / 2);

    overflow-x: hidden;
  `,

  grid: css`
    display: grid;
    grid-template-columns: repeat(12, 1fr);

    margin: 0 calc(var(--gutter-half) * -1);

    & > * {
      border-left: 1px solid var(--border-color);
      padding-inline: var(--gutter-half);
    }
  `,
}

export default React.forwardRef(Segmented)
